module.exports = __webpack_public_path__ + "img/香青兰.2a20eef8.jpg";